// @flow
import parseUri from 'app/packages/url/parseUri.external.js'; // eslint-disable-line import/extensions

// Strips the scheme and trailing slash of a URL, and if domain_only flag
// is set, just returns the domain
// e.g. www.foo.com/pin/194839434391/ will return: www.foo.com
export const prettifyUrl = (url: string, domain_only?: boolean) => {
  if (domain_only) {
    let parsed_url = url;
    if (!/.*?:\/\//.test(url)) {
      // No scheme, so add one so our parser gives us good values
      parsed_url = 'http://' + parsed_url;
    }
    parsed_url = parseUri(parsed_url);
    return parsed_url.host;
  }

  // strip the scheme, if any
  url = url.replace(/.*?:\/\//g, '');

  // strip trailing slash, if any
  url = url.replace(/\/$/, '');

  return url;
};

// Copying logic from python in order to use in the frontend
// https://phabricator.pinadmin.com/diffusion/P/browse/master/core/utils/pin_utils.py$493
export const normalizeDomain = (link: string) => {
  const re = new RegExp('(?:.+?://)?(?:www[d]*.)?([^/:#?]*)', 'i');
  // The format of the response from a regex exec call is rather complicated
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/exec
  // we would only care about the first result as that's what the python function does as well
  const execObj = re.exec(link);
  const prettyLink = (execObj && execObj[1]) || '';
  // Some old links have a trailing dot that we need to strip
  return prettyLink.toLowerCase().replace(/\.$/, '');
};
